import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: "Maria Gonzalez",
    role: "Regular Customer",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18403c4e4-1763295192007.png",
    avatarAlt: "Professional headshot of Hispanic woman with long dark hair wearing elegant navy blazer smiling warmly",
    rating: 5,
    text: "Montesanto brings authentic Italian flavors to Etobicoke! Their cornetti remind me of my trips to Rome. The family atmosphere and genuine warmth make every visit special. I come here every Saturday morning for my weekly treat.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "James Patterson",
    role: "Corporate Client",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ec6e6364-1763296664036.png",
    avatarAlt: "Professional business portrait of Caucasian man with short gray hair in formal dark suit and tie",
    rating: 5,
    text: "We've been using Montesanto for our corporate events for over a year. Their catering service is impeccable—always on time, beautifully presented, and absolutely delicious. Our clients are always impressed with the quality.",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Sophia Chen",
    role: "Wedding Customer",
    avatar: "https://images.unsplash.com/photo-1731603827045-75fea9c24e31",
    avatarAlt: "Elegant portrait of Asian woman with styled black hair wearing pearl necklace and soft pink dress",
    rating: 5,
    text: "They created our dream wedding cake! The consultation process was wonderful—they listened to every detail and brought our vision to life. The cake was not only stunning but tasted incredible. All our guests raved about it!",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "Roberto Bianchi",
    role: "Italian Food Enthusiast",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1edd0d618-1763293656723.png",
    avatarAlt: "Warm portrait of Italian man with salt and pepper beard wearing casual olive green shirt smiling genuinely",
    rating: 5,
    text: "As someone who grew up in Italy, I'm very particular about authentic Italian baking. Montesanto exceeds expectations every time. Their bread reminds me of my nonna's kitchen. This is the real deal—traditional recipes done right.",
    date: "1 week ago"
  }];


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [testimonials?.length]);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
  };

  return (
    <section className="py-16 bg-background">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-warning/10 border border-warning/20 mb-4">
            <Icon name="Star" size={16} color="var(--color-warning)" className="fill-current" />
            <span className="text-sm font-medium text-warning">4.7 Rating • 471+ Reviews</span>
          </div>
          <h2 className="font-serif text-4xl font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Real experiences from our extended Italian famiglia
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="overflow-hidden">
            {testimonials?.map((testimonial, index) =>
            <div
              key={testimonial?.id}
              className={`transition-opacity duration-500 ${
              index === currentIndex ? 'opacity-100' : 'opacity-0 absolute inset-0'}`
              }>

                <div className="bg-card rounded-2xl p-8 lg:p-12 border border-border shadow-warm">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                      <Image
                      src={testimonial?.avatar}
                      alt={testimonial?.avatarAlt}
                      className="w-full h-full object-cover" />

                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-lg text-foreground">
                        {testimonial?.name}
                      </h4>
                      <p className="text-sm text-muted-foreground">{testimonial?.role}</p>
                    </div>
                    <div className="flex gap-1">
                      {[...Array(testimonial?.rating)]?.map((_, i) =>
                    <Icon
                      key={i}
                      name="Star"
                      size={20}
                      color="var(--color-warning)"
                      className="fill-current" />

                    )}
                    </div>
                  </div>

                  <blockquote className="text-lg text-foreground leading-relaxed mb-6">
                    "{testimonial?.text}"
                  </blockquote>

                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Calendar" size={16} />
                    <span>{testimonial?.date}</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-center items-center gap-4 mt-8">
            <button
              onClick={handlePrevious}
              className="w-12 h-12 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-all duration-300"
              aria-label="Previous testimonial">

              <Icon name="ChevronLeft" size={20} />
            </button>

            <div className="flex gap-2">
              {testimonials?.map((_, index) =>
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                index === currentIndex ? 'w-8 bg-primary' : 'w-2 bg-muted'}`
                }
                aria-label={`Go to testimonial ${index + 1}`} />

              )}
            </div>

            <button
              onClick={handleNext}
              className="w-12 h-12 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-all duration-300"
              aria-label="Next testimonial">

              <Icon name="ChevronRight" size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>);

};

export default TestimonialCarousel;